export default "__VITE_ASSET__BFzRGLj___"